"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.ERROR = exports.EHR_MYCHART = void 0;
const EHR_MYCHART = exports.EHR_MYCHART = 'mychart';

// Error types
const ERROR = exports.ERROR = {
  ERROR_EHR_LOGIN: 'ERROR_EHR_LOGIN',
  // general login error
  ERROR_EHR_INVALID_PID: 'ERROR_EHR_INVALID_PID',
  // pid is invalid or missing
  ERROR_EHR_INVALID_ACCESS_TOKEN: 'ERROR_EHR_INVALID_ACCESS_TOKEN',
  // access_token is invalid or missing
  ERROR_EHR_INVALID_SOURCE_SYSTEM: 'ERROR_EHR_INVALID_SOURCE_SYSTEM',
  // source_system is invalid or missing
  ERROR_EHR_NOT_AUTHORIZED_BY_USER: 'ERROR_EHR_NOT_AUTHORIZED_BY_USER' // user rejects sharing information from EHR
};